'use client'

import { type FC, useEffect, useRef } from 'react'

import { useAnalytics } from '../../context/Analytics'
import { colors } from '../../theme/colors'
import BlankTargetLink from '../BlankTargetLink'

export const TrustPilotVariant = {
  Default: '5419b732fbfb950b10de65e5',
  Large: '53aa8807dec7e10d38f59f32',
  MicroCombo: '5419b6ffb0d04a076446a9af',
}

interface TrustPilotWidgetProps {
  variant?: string
  textColor?: string
}

const TrustPilotWidget: FC<TrustPilotWidgetProps> = ({
  variant = TrustPilotVariant.Default,
  textColor = colors.Ink[800],
}) => {
  const { track, events } = useAnalytics()
  const ref = useRef(null)
  useEffect(() => {
    // If window.Trustpilot is available it means that we need to load the TrustPilotWidget from our ref.
    // If it's not, then the trustpilot script isn't loaded just yet.
    // When it is, it will automatically load the TrustPilotWidget.
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true)
    }
  }, [])

  let dataStyleHeight = '24px'

  if (variant === TrustPilotVariant.Large) {
    dataStyleHeight = '150px'
  }

  return (
    <div
      ref={ref}
      id="trustpilot-widget"
      className="trustpilot-widget"
      data-testid="trustpilot-widget"
      data-locale="en-US"
      data-businessunit-id="5d5198b996353100018ec59f"
      data-template-id={variant}
      data-style-height={dataStyleHeight}
      data-style-width="100%"
      data-theme="light"
      data-text-color={textColor}
      onClick={() => track?.(events.INTERACTION.ClickTrustPilotWidget)}
    >
      <BlankTargetLink href="https://www.trustpilot.com/review/missionlane.com" />
    </div>
  )
}

export default TrustPilotWidget
